/**
 * 通用提问组件
 * @Author: FJJ
 * @History:
 * @Date      Version Remarks
 * ========= ======= ======================================================
 * 2022.10.26      1.0     First version   * @param type  '1':  提问历史+ 可提问列表， '2':  纯提问历史， '3'： 纯可提问列表,  '4'： 购物车批量咨询, 需要去 getCartIds 拿IDS，   默认 1
 * 2024.09.25      2.0     Second version  dop用 只有 纯提问历史

 * @param inCart购物车商品
 * @cartId 购物车 ID
 *
 *
 * Copyright 2017-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import PropTypes from "prop-types";
import {Row, Divider,Drawer,Spin,} from 'antd';
import Locale from "@utils/locale";
import dayjs from "dayjs";
import { isEmpty,isEmptyObject }  from '@utils/utils';
import "./pop-ques.less"
const localeLang = Locale.current();
class PopQuestion extends React.Component {
    static propTypes = {
        product: PropTypes.object.isRequired,
        title: PropTypes.string,
        btnClass: PropTypes.string,
        iconClass: PropTypes.string,
    }
    static defaultProps = {
        type:'1',
        title:'',
        btnClass:'btn btn-primary',
        iconClass:'',
        product:{},
        inCart:'',
        poItemId:'',
        cartId:'',
        tipsNum:0,//按钮显示的数字及小红点，大于0才显示
        hotDotShow: false, // 显示小红点
        fromType: 'cart',// 'po': po详情，'product':商品详情 , 默认/其他是 'cart', 发送到接口的参数
        iconSvg: null,//有传即显示
        hasGroup:false, // 含有拼团商品
    };
    constructor(props) {
        super(props);
        this.__getServerLanguage = __getServerLanguage;
        this.state={
            quesList :[],
            loading:false,
            visible:false,
            loadingHistory:false,
            quesText:'',
            historyFileUrl:'',
            selectCartIds:[]
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    loadingHistory(flag){
        this.setState({
            loadingHistory: flag,
        });
    }
    /**
     * 获取预设问题列表
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=82#2750
     * */
    getList(selectCartIds){
        const sUrl = "/data/mc/r/shopping-cart/query-question";
        const data = {};
        this.loading(true)
        this.postHttpAction(sUrl,data,resData=>{
            // 响应结果
            const { success, valid, models, } = resData;
            if (success && valid) {
                this.loading(false)
                // 返回状态
                this.setState({
                    quesList: models||[],
                    selectCartIds:selectCartIds
                })
            }
        })
    }
    /**
     * 获取历史提问和回复列表 http://rap.essa.top:88/workspace/myWorkspace.do?projectId=53#7472
     * /mc/r/inquiry/query-cart-question
     * */
    getHistoryList(flag=true){
        const {skuId,fromType,poItemId, buyerId, buyerAccountId} = this.props;
        if(skuId){
            const sUrl = "/mg/po/essa-one/query-cart-question";
            const data = {
                buyerId:buyerId,
                buyerAccountId:buyerAccountId,
                lang: localeLang,
                skuId: skuId,
                fromType: fromType,
                // poItemId:poItemId 目前不会有
            };
            this.loadingHistory(true)
            this.postHttpAction(sUrl,data,resData=>{
                // 响应结果
                const { success, valid, models, } = resData;
                this.loadingHistory(false)
                if (success && valid) {
                    // 返回状态
                    const all = models||[];
                    this.setState({
                        historyList:all,
                    })
                    if(flag){
                        document.querySelector('#ques-list-warp').scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                            inline: "center"
                        })

                    }
                }
            })
        }

    }
    /**
     * 请求
     * */
    postHttpAction(sUrl,data,callback){
        return $.ajax({
            url: sUrl,
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(data),
            success:(res)=>{
                callback(res)
            }
        });
    }
    /**
     * 是否显示面板
     *
     * '1':  提问历史+ 可提问列表，
     * '2':  纯提问历史，
     * '3'： 纯可提问列表,
     * '4'： 购物车批量咨询, 需要去 getCartIds 拿IDS，
     *
     * @param flag 是否打开
     * @param hasGroup
     * */
    showQuesPanel(flag=false,hasGroup=false){
        // if(hasGroup){// 拼团不能发起咨询 ： 勾选的商品含有拼团商品，无法发起咨询。
        //     message.info(this.__getServerLanguage("GouXuanDeShangPinHanYouPinTuanShangPin"));
        //     return false
        // }
        if(flag){
            this.getHistoryList();
        }
        this.setState({
                visible:flag,
                quesText:''
            })
    }
    /**
     * 提问历史
     * 自主提问用分号隔开 todo
     * */
    renderHistory(list=[]){
        let renChild = []
        list.forEach((item={},index)=>{
            if(item.type=='1'){
                let children = [],childList = item.questionVOList;
                childList.forEach((txt,inx)=>{
                    // if(!isEmpty(txt))children.push(<li key={inx}><span className="icon iconfont icon-question-filled"></span>{txt}</li>)
                    let str = []
                    let flagStartInx = true;
                    if(txt.questionType=='2'){
                        const splitList = txt.question.split(';')||[];
                        splitList.forEach((itemStr,subInx)=>{
                            if(!isEmpty(itemStr)){
                                str.push(<li key={subInx}>{flagStartInx&&<span className="icon iconfont icon-question-filled"></span>}{itemStr}</li>);
                                flagStartInx = false
                            }
                        })
                    }else if(!isEmpty(txt.question)) {
                        str = (<li key={inx}><span className="icon iconfont icon-question-filled"></span><span>{txt.question}</span></li>)
                    }
                    children.push(<div>{str}</div>)

                })
                renChild.push( <Row>
                    {item.askTime?<Divider>{dayjs(item.askTime).format("YYYY-MM-DD HH:mm:ss")}</Divider>:''}
                        <div className={'flex-item-right'}>
                            <div className={"his-right"}>
                                <p>{item.name}</p>
                                <ul>
                                    {children}
                                </ul>
                            </div>
                            <div className={'historyPicFile'}>
                                {item.fileUrl&&<img src={item.fileUrl} />}
                            </div>
                        </div>
                </Row>)
            }else {
                let subChild = [], subList = item.questionVOList||[];//'subItem = item.questionVO||{};
                subList.forEach((subItem,inx)=>{
                    let str = []
                    if(subItem.questionType=='2'){
                        const splitList = subItem.question.split(';')||[];
                        let flagStartInx = true;
                        splitList.forEach((itemStr,inx)=>{
                           if(!isEmpty(itemStr)){
                               str.push(<p className={"font-bold"}>{flagStartInx&&<span className="icon iconfont icon-question-filled"></span>}{itemStr}</p>)
                               flagStartInx = false;
                           }
                        })
                    }else if(!isEmpty(subItem.question)) {
                        str = (<p className={"font-bold"}><span className="icon iconfont icon-question-filled"></span>{subItem.question}</p>)
                    }
                    subChild.push(<li>
                            {str}
                            <p>{item.translateClicked?subItem.answer:subItem.originalAnswer}</p>
                        </li>)
                })
                renChild.push( <Row>
                    {item.askTime?<Divider>{dayjs(item.askTime).format("YYYY-MM-DD HH:mm:ss")}</Divider>:''}
                        <div className={'flex-item list-width'}>
                            <div className={"his-left-pic"}>
                                {item.fileUrl&&<img src={item.fileUrl} />}
                            </div>
                            <div className={'his-left'}>
                                <p>{item.name}</p>
                                <ul>
                                    {subChild}
                                </ul>
                                <div className={"btn-translate"}
                                     onClick={()=>this.onChangeTranslate(index,!item.translateClicked)}>
                                    <span className={"icon iconfont icon-translate"}></span>{item.translateClicked?this.__getServerLanguage("XianShiYuanWen"):this.__getServerLanguage("FanYi")}</div>
                            </div>
                        </div>
                </Row>)
            }
        })
        return renChild
    }

    /***
     * 点击翻译
     */
    onChangeTranslate(key,flag){
        const {historyList} = this.state;
        let newList = [...historyList]
        newList[key].translateClicked = flag;
        this.setState({
            historyList: newList
        })
    }
    componentDidMount() {
        if( this.props.onRef)  this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const {title, btnClass,iconClass,tipsNum,hotDotShow,iconSvg,hasGroup } = this.props;
        const { visible, historyList, loadingHistory } = this.state;
        return (<div className={"pop-ques-wrap"}>
                <div className={'btn_pop-ques-wrap ' +btnClass} title={title} onClick={()=>this.showQuesPanel(true,hasGroup)}>
                    {iconClass&&<span className={'iconfont '+iconClass}></span>}
                    {iconSvg?iconSvg:""}
                    <span className="ml_2 txt">{title}</span>
                    {tipsNum>0?<span className="ml_6 fw_700">{tipsNum}</span>:null}
                    {hotDotShow?<span className="red-dot"></span>:null}
                </div>
            {visible&&<Drawer
                title={this.__getServerLanguage("ZiXunChanPin")}
                placement="right"
                width={700}
                onClose={()=>this.showQuesPanel(false)}
                open={visible}
            >
                {/* 咨询产品 */}
                <div className={"pop-ques-scroll-wrap"}>
                    {/* 咨询产品 历史*/}
                    <div className={"history-list-warp"}>
                        <Spin spinning={loadingHistory}>
                            {this.renderHistory(historyList)}
                        </Spin>
                    </div>
                    {/* 咨询产品 历史 end*/}

                </div>
            </Drawer>}
        </div>)

    }
}

export default PopQuestion;

